import { MARCAR_LEIDO, GET_COMPLETOS } from '../actions';

export default function(state=null, action){
  switch (action.type) {
    case GET_COMPLETOS:
      return action.payload.data;

    case MARCAR_LEIDO:
      if (action.payload.data!==undefined && action.payload.data.idcontenido!==undefined &&
          state!==undefined && (state[action.payload.data.idcontenido]===undefined &&
          state[action.payload.data.idcontenido]!=="1")) {
        let mod = Object.assign({}, state);
        mod[action.payload.data.idcontenido] = "1";
        return mod;
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leidos_reducer.js